// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['colaborador_satya']


const DEFAULT_URL = "/familia-cliente";

const familiaClienteBreadCrumb = [
  {
    label: "Home",
    to: "Home",
  },
  {
    label: "Família de Cliente",
    to: "familiaCliente",
  },
];

export default [
  {
    path: DEFAULT_URL,
    name: "familiaCliente",
    component: () => import('@/views/FamiliaCliente/FamiliaClienteListPage.vue'),
    meta: {
      roles: ROLES,
      title: "Família de Cliente",
      breadcrumb: familiaClienteBreadCrumb,
    },
  },
];
